import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBrandStatInfoAction, getBrandInfoAction, setBrandSelFilterIndexAction, setSetBrandFilterDataAction } from '../../modules/common/brandModule';
import {isMobileOnly} from 'react-device-detect';

const BrLangFindFilterBlock = styled.div`
    display: ${props => props.display};
    ${isMobileOnly?"padding:10px":"padding: 20px 30px"};
    background-color: #f4f4f4;

    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const BrLangFindFilterUlBlock = styled.ul`
    ${!isMobileOnly&&`
        float: left;
        margin-left: 52px;    
    `};
    &:nth-child(1) {
        margin-left: 0;
    }

    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const BrLangFindFilterLiBlock = styled.li`
    float: left;
    margin-left: 8px;
    pointer-events: ${props => props.disable};
`;

const BrLangFindFilterBtn = styled.button`
    line-height: 1;
    color: ${props => props.colorF};
    font-size: 20px;
    font-weight: 500;
`;

const SearchLangFindFilterMBlock = styled.div`
    width: 100%;
    //margin-left: -4vw;

    .mobile-brand-conatiner {
        overflow: scroll;
        overflow-y: hidden;
        display: flex;
        //padding: 0 0 10px 0;
        //width: max-content;
        .mobile-band {
            margin-left: 8px;
        }

        .mobile-band:last-child {
            padding-right: 4vw;
        }
        .mobile-band:first-child {
            margin-left: 0px;
        }
    }

`;

const BrFilterList = [
    { value: 'ㄱ', label: '가' }, { value: 'ㄴ', label: '나' }, { value: 'ㄷ', label: '다' }, { value: 'ㄹ', label: '라' },
    { value: 'ㅁ', label: '마' }, { value: 'ㅂ', label: '바' }, { value: 'ㅅ', label: '사' },
    { value: 'ㅇ', label: '아' }, { value: 'ㅈ', label: '자' }, { value: 'ㅊ', label: '차' }, { value: 'ㅋ', label: '카' },
    { value: 'ㅌ', label: '타' }, { value: 'ㅍ', label: '파' }, { value: 'ㅎ', label: '하' },
    { value: 'A' }, { value: 'B' }, { value: 'C' }, { value: 'D' }, { value: 'E' }, { value: 'F' }, { value: 'G' },
    { value: 'H' }, { value: 'I' }, { value: 'J' }, { value: 'K' }, { value: 'L' }, { value: 'M' }, { value: 'N' },
    { value: 'O' }, { value: 'P' }, { value: 'Q' }, { value: 'R' }, { value: 'S' }, { value: 'T' }, { value: 'U' },
    { value: 'V' }, { value: 'W' }, { value: 'X' }, { value: 'Y' }, { value: 'Z' },
    { value: '0-9' },
];


const BrLangFindFilter = ({ showBlock }) => {
    const dispatch = useDispatch();

    const { brandStat, error, loading, brandSelFilterIndex, brandInfo } = useSelector(
        ({ brandItemsReducer, loadingReducer }) => ({
            brandStat: brandItemsReducer.brandStat,
            error: brandItemsReducer.error,
            loading: loadingReducer['brand/STAT'],
            brandSelFilterIndex: brandItemsReducer.brandSelFilterIndex,
            brandInfo: brandItemsReducer.brandInfo,
        })
    );

    useEffect(() => {
        //console.log( "brandstat111 = " + brandStat);
        if (brandStat === null) {
            // console.log("getBrandStatInfoAction is Called !!! ")
            dispatch(getBrandStatInfoAction());
        }
        return () => {
            // console.log( "brandstat111 end = " + brandStat);
        };
    }, [dispatch, brandStat]);

    useEffect(() => {
        //console.log( "brandstat = " + brandStat);
        //console.log( "curFilterIndexandstat = " + brandSelFilterIndex);
        if (brandStat !== null && brandSelFilterIndex === -1 && brandInfo === null) {

            dispatch(getBrandInfoAction("all", "0", "0"));
            dispatch(setSetBrandFilterDataAction({ data: "all", type: "0", offset: "0" }));
        }

        return () => {
            //console.log( "curFilterIndex end= " + brandSelFilterIndex);
        };
    }, [brandStat]);


    //필터 선택
    const handleClick = (index) => {

        //all 호출
        if (index === brandSelFilterIndex) {
            dispatch(getBrandInfoAction("all", "0", "0"));
            dispatch(setSetBrandFilterDataAction({ data: "all", type: "0", offset: "0" }));
            dispatch(setBrandSelFilterIndexAction(-1));
            return;
        }
        if (index < 14) {
            dispatch(getBrandInfoAction(BrFilterList[index].value, "0", "0"));
            dispatch(setSetBrandFilterDataAction({ data: BrFilterList[index].value, type: "0", offset: "0" }));
        }
        else if (index > 13 && index < 40) {
            dispatch(getBrandInfoAction(BrFilterList[index].value, "1", "0"));
            dispatch(setSetBrandFilterDataAction({ data: BrFilterList[index].value, type: "1", offset: "0" }));
        }
        else {
            dispatch(getBrandInfoAction("0", "1", "0"));
            dispatch(setSetBrandFilterDataAction({ data: "0", type: "1", offset: "0" }));
        }
        //setCurFilterIndex(index)
        dispatch(setBrandSelFilterIndexAction(index));

    }

    const isNumberEnable = () => {
        let retValue = false;
        brandStat.eng.map((item) => {
            if (isNaN(item.key) === false) {
                // console.log("isNumberEnable = " +item.key)
                retValue = true;
            }

            return retValue;
        });

        return retValue;
    }

    if (error !== null && error !== undefined && brandStat === null) {
        //console.log("111error=" + error + "brandstat = " + brandStat);
        return <BrLangFindFilterBlock display={showBlock}>오류발생</BrLangFindFilterBlock>
    }

    if (brandStat === null || brandStat.length === 0) {
        //console.log("333error=" + error + "brandstat = " + brandStat);
        return <BrLangFindFilterBlock display={showBlock}></BrLangFindFilterBlock>
    }

    const isSafari = () => {
        var ua = navigator.userAgent.toLocaleLowerCase();
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        //console.log("ua = " + ua);
        var is_safari = ua.indexOf("safari") > -1 && ua.indexOf("chrom") === -1;
        //console.log("is_safari = " + is_safari);
        return is_safari;
    }

    return (
        isMobileOnly?
        <BrLangFindFilterBlock display={showBlock}>
            <SearchLangFindFilterMBlock>
                <div className="mobile-brand-conatiner">
                    {
                        BrFilterList.map((item, index) => {
                            if (index < 14 && brandStat.han.find(x => x.key === item.value)) {
                                return (
                                    <div className="mobile-band" key={item.value} onClick={() => handleClick(index)}
                                        disable={brandStat.han.find(x => x.key === item.value) ? '' : 'none'} >
                                        <BrLangFindFilterBtn colorF={index === brandSelFilterIndex ? '#111' : '#999'}>
                                            {item.label}
                                        </BrLangFindFilterBtn>
                                    </div>)
                            }
                            return (null);
                        })
                    }
                    {
                        //영어
                        BrFilterList.map((item, index) => {
                            if (index > 13 && index < 40 && brandStat.eng.find(x => x.key === item.value) ) {
                                return (
                                    <div className="mobile-band"  key={item.value} onClick={() => handleClick(index)}
                                        disable={brandStat.eng.find(x => x.key === item.value) ? '' : 'none'} >
                                        <BrLangFindFilterBtn colorF={index === brandSelFilterIndex ? '#111' : '#999'}>
                                            {item.value}
                                        </BrLangFindFilterBtn>
                                    </div>)
                            }
                            return (null);
                        })
                    }
                    {
                        //숫자
                        BrFilterList.map((item, index) => {
                            if (index > 39 && isNumberEnable()) {
                                return (
                                    <div className="mobile-band" /* style={isSafari() ? { marginLeft: "3px" } : { marginLeft: "8px" }} */ key={item.value} onClick={() => handleClick(index)}
                                        disable={isNumberEnable() ? '' : 'none'} >
                                        <BrLangFindFilterBtn colorF={index === brandSelFilterIndex ? '#111' : '#999'}>
                                            {item.value}
                                        </BrLangFindFilterBtn>
                                    </div>)
                            }
                            return (null);
                        })
                    }
                </div>
            </SearchLangFindFilterMBlock>
        </BrLangFindFilterBlock>
        :
        <BrLangFindFilterBlock display={showBlock}>
            <BrLangFindFilterUlBlock>
                {
                    //한글
                    BrFilterList.map((item, index) => {
                        if (index < 14) {
                            return (
                                <BrLangFindFilterLiBlock style={isSafari() ? { marginLeft: "3px" } : { marginLeft: "8px" }} key={item.value} onClick={() => handleClick(index)}
                                    disable={brandStat.han.find(x => x.key === item.value) ? '' : 'none'}>
                                    <BrLangFindFilterBtn colorF={index === brandSelFilterIndex ? '#111' : '#999'}>
                                        {item.label}
                                    </BrLangFindFilterBtn>
                                </BrLangFindFilterLiBlock>)
                        }
                        return (null);
                    })
                }
            </BrLangFindFilterUlBlock>
            <BrLangFindFilterUlBlock>
                {
                    //영어
                    BrFilterList.map((item, index) => {
                        if (index > 13 && index < 40) {
                            return (
                                <BrLangFindFilterLiBlock style={isSafari() ? { marginLeft: "3px" } : { marginLeft: "8px" }} key={item.value} onClick={() => handleClick(index)}
                                    disable={brandStat.eng.find(x => x.key === item.value) ? '' : 'none'}>
                                    <BrLangFindFilterBtn colorF={index === brandSelFilterIndex ? '#111' : '#999'}>
                                        {item.value}
                                    </BrLangFindFilterBtn>
                                </BrLangFindFilterLiBlock>)
                        }
                        return (null);
                    })
                }
            </BrLangFindFilterUlBlock>
            <BrLangFindFilterUlBlock>
                {
                    //숫자
                    BrFilterList.map((item, index) => {
                        if (index > 39) {
                            return (
                                <BrLangFindFilterLiBlock style={isSafari() ? { marginLeft: "3px" } : { marginLeft: "8px" }} key={item.value} onClick={() => handleClick(index)}
                                    disable={isNumberEnable() ? '' : 'none'}>
                                    <BrLangFindFilterBtn colorF={index === brandSelFilterIndex ? '#111' : '#999'}>
                                        {item.value}
                                    </BrLangFindFilterBtn>
                                </BrLangFindFilterLiBlock>)
                        }
                        return (null);
                    })
                }
            </BrLangFindFilterUlBlock>
        </BrLangFindFilterBlock>

    );

};

export default BrLangFindFilter;
